"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Step = _interopRequireDefault(require("@mui/material/Step"));
var _StepLabel = _interopRequireDefault(require("@mui/material/StepLabel"));
var _react = _interopRequireDefault(require("react"));
var _String = _interopRequireDefault(require("./String.js"));
var _StepperStepModule = _interopRequireDefault(require("./StepperStep.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Stepper step component
 */const StepperStep = props => {
  const {
    active,
    completed,
    connector,
    disabled,
    index,
    label,
    onClick,
    last,
    value
  } = props;
  const handleClick = () => {
    if (!disabled) {
      onClick?.(value);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Step.default, {
    active: active,
    completed: completed,
    connector: connector,
    disabled: disabled,
    index: index,
    last: last,
    onClick: handleClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StepLabel.default, {
      className: !active && !disabled && onClick ? _StepperStepModule.default.label : null,
      onClick: handleClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        bold: true,
        color: "textSecondary",
        str: label,
        variant: "caption"
      })
    })
  });
};
var _default = exports.default = StepperStep;